<template>
  <div
    class="tw-m-4 tw-bg-white tw-shadow-lg  tw-text-left tw-rounded tw-px-8 tw-pt-2 tw-pb-8 tw-mb-4"
  >
    <div v-if="project && !loading">
      <p class="tw-mx-4 tw-block tw-mt-8 tw-font-bold tw-text-2xl">
        Project Name: {{ project.name }}
      </p>

      <v-img
        class="white--text align-end"
        height="250px"
        :src="project.file.split(',')[0]"
        lazy-src="https://picsum.photos/id/11/100/60"
      >
      </v-img>
      <br />

      <div class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg">
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          1. Project Details
        </p>

        <p class="tw-mx-4 tw-block">
          <strong>Description:</strong> {{ project.description }}
        </p>
        <p class=" tw-px-4"><strong>Address:</strong> {{ project.address }}</p>
        <p class="tw-block tw-px-4">
          <strong>Sector:</strong> {{ project.sector }}
        </p>
        <p class="tw-block tw-px-4" v-if="project.project_type">
          <strong>Status:</strong> {{ project.project_type }}
        </p>
      </div>

      <div
        class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg"
        v-if="project.verification_number"
      >
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          2. Verification Details
        </p>
        <div class="tw-flex tw-flex-wrap">
          <section class="tw-w-full md:tw-w-1/2">
            <p class="tw-block tw-px-4">
              <strong>Verification Date:</strong>
              {{ project.verification_date }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.verification_number">
              <strong>Verification Number:</strong>
              {{ project.verification_number }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.validated_by">
              <strong>Validated by:</strong> {{ project.validated_by }}
            </p>
          </section>
          <section class="tw-w-full md:tw-w-1/2">
            <p class="tw-block tw-px-4" v-if="project.approved_by">
              <strong>Approved by:</strong> {{ project.approved_by }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.validation_number">
              <strong>Validation Number:</strong>
              {{ project.validation_number }}
            </p>
            <p class="tw-block tw-px-4" v-if="project.verified_by">
              <strong>Verified by:</strong> {{ project.verified_by }}
            </p>
          </section>
        </div>
      </div>

      <div
        class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg"
        v-if="project.certification_report"
      >
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          3. Certification Details
        </p>

        <div class="tw-flex tw-flex-wrap">
          <section class="tw-w-full md:tw-w-1/2">
            <p class="tw-block tw-px-4" v-if="project.certified_by">
              <strong>Certified by:</strong> {{ project.certified_by }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.certified_number">
              <strong>Certification Number:</strong>
              {{ project.certified_number }}
            </p>
            <p class="tw-block tw-px-4" v-if="project.certified_date">
              <strong>Certification Date:</strong> {{ project.certified_date }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.life_cycle">
              <strong>Life Cycle:</strong> {{ project.life_cycle }}
            </p>
          </section>

          <section class="tw-w-full md:tw-w-1/2">
            <p
              class="tw-block tw-px-4"
              v-if="project.carbon_reduction_capacity"
            >
              <strong>Total Carbon Reduction Capacity:</strong>
              {{ project.carbon_reduction_capacity }} tCO2e
            </p>

            <p class="tw-block tw-px-4" v-if="project.carbon_balance">
              <strong>Carbon Balance:</strong>
              {{ project.carbon_balance }} tCO2e
            </p>

            <p class="tw-block tw-px-4" v-if="project.price">
              <strong>Price(₦):</strong> {{ project.price }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.certification_report">
              <a :href="project.certification_report" target="_blank"
                >View Certification Report</a
              >
            </p>
          </section>
        </div>
      </div>

      <div class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg">
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          Project Owner Details
        </p>
        <p class="tw-block tw-px-4" v-if="project.owner_id">
          <strong>Owner Name:</strong> {{ project.owner_id.admin.firstName }}
          {{ project.owner_id.admin.lastName }}
        </p>

        <p class="tw-block tw-px-4" v-if="project.owner_id">
          <strong>Owner Phone Number:</strong>
          {{ project.owner_id.admin.phoneNumber }}
        </p>

        <p class="tw-block tw-px-4" v-if="project.owner_id">
          <strong>Owner Email:</strong>
          {{ project.owner_id.admin.email }}
        </p>
      </div>
      <div v-if="project && user" class="inline-flex mt-4 ">
        <div v-if="project.project_type == 'Verification'" class="inline-flex">
          <router-link
            class="tw-block tw-mt-4 lg:tw-inline-block tw-bg-white tw-text-center tw-bg-eko-light tw-text-white tw-rounded tw-font-semibold tw-text-lg md:tw-px-4  lg:tw-mt-0 tw-mr-4 md:tw-py-1 tw-text-white btns"
            :to="{
              name: 'admin-edit-certification',
              params: { id: project._id },
            }"
          >
            Certify Project
          </router-link>
        </div>

        <div v-if="project.project_type == 'Certification'" class="inline-flex">
          <router-link
            class="tw-block tw-mt-4 lg:tw-inline-block tw-bg-white tw-text-center tw-bg-eko-light tw-text-white tw-rounded tw-font-semibold tw-text-lg md:tw-px-4  lg:tw-mt-0 tw-mr-4 md:tw-py-1 tw-text-white btns"
            :to="{
              name: 'admin-edit-lisiting',
              params: { id: project._id },
            }"
          >
            List Project
          </router-link>
        </div>

        <div class="tw-flex tw-flex-wrap">
          <div v-if="project.project_type == 'Listing'">
            <router-link
              class="tw-block tw-mt-4 lg:tw-inline-block tw-bg-white tw-text-center tw-bg-eko-orange tw-text-white tw-rounded tw-font-semibold tw-text-lg md:tw-px-4  lg:tw-mt-0 tw-mr-4 md:tw-py-1 tw-text-white btns"
              :to="{
                name: 'admin-edit-lisiting',
                params: { id: project._id },
              }"
            >
              Edit Project
            </router-link>
          </div>

          <div
            v-if="
              project.project_type == 'Listing' && project.approved == false
            "
          >
            <button
              @click="approveProject"
              class="tw-block tw-mt-4 lg:tw-inline-block tw-bg-white tw-text-center tw-bg-eko-light tw-text-white tw-rounded tw-font-semibold tw-text-lg md:tw-px-4  lg:tw-mt-0 tw-mr-4 md:tw-py-1 tw-text-white btns"
            >
              Approve
            </button>
          </div>
        </div>
      </div>
      <p
        v-if="project.project_type == 'Listing' && project.approved == true"
        class="tw-text-green-700 tw-mt-4"
      >
        This project has been successfully approved
      </p>

      <vue-element-loading
        v-if="loading"
        :active="loading"
        :is-full-screen="true"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: {},
      dialog: false,
      errors: {},
      loading: true,
      token: "",
      project: null,
      data: {},
      company: {},
    };
  },
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    this.getProject();
  },
  methods: {
    getProject() {
      const self = this;
      axios
        .get(`${this.$baseUrl}/admin/project/${this.$route.params.id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          this.project = response.data.project;
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          console.log(error.response.data);
        });
    },
    approveProject() {
      this.loading = true;
      const self = this;
      axios
        .post(
          `${this.$baseUrl}/admin/project/approve`,
          {
            project_id: this.project._id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          this.project.approved = true;
          self.$swal("Success!", "Project Approved Successfully", "success");
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data
            ? error.response.data.message
            : "An error occured";
          self.$swal("Error!", err_msg, "error");
        });
    },
    transferProject() {
      this.errors = {};
      this.loading = true;
      const self = this;
      let deny = false;
      if (!this.data.email) {
        this.errors.email = true;
        deny = true;
      }

      if (deny) {
        return;
      }

      this.data.owner_id = this.project.owner_id._id;
      this.data._id = this.project._id;
      axios
        .post(`${this.$baseUrl}/project/transfer`, this.data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          self.$swal("Success!", "Project Transferred Successfully", "success");
          self.loading = false;
          self.success = true;
          self.dialog = false;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          let err_msg = error.response.data
            ? error.response.data.message
            : "An error occured";
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="css" scoped>
.add-btn {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 20px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  font-size: 36px;
}
.my-img {
  width: 50%;
  height: 50%;
  margin: auto;
}
a {
  color: white !important;
}

btns {
  color: white !important;
}
</style>
